import Select from './Select';
import Group from './Group';
import Item from './Item';
Select.Group = Group;
Select.Item = Item;
export default Select;